import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { TieredMenu } from 'primereact/tieredmenu';
import PrimeReact from 'primereact/api';
import('primereact/resources/themes/lara-light-indigo/theme.css');  //theme
import('primereact/resources/primereact.min.css');                  //core css
import('primeicons/primeicons.css');                                //icons

PrimeReact.zIndex = {
    modal: 2100,    // dialog, sidebar
    overlay: 2000,  // dropdown, overlaypanel
    menu: 2000,     // overlay menus
    tooltip: 2100,   // tooltip
    toast: 2200     // toast
}

const Menu = ({ links, user_data }) => {
    const menu = useRef(null);

    const {
        list_your_rv_estimate_earnings_path,
        search_rvs_for_rent_path,
        sales_path,
        new_user_session_path,
        new_user_registration_path,
        admin_dashboard_path,
        conversations_path,
        calendar_path,
        fleet_path,
        reservations_path,
        check_in_out_path,
        guests_path,
        settings_path,
        favorites_path,
        trips_path,
        past_trips_path,
        edit_user_registration_path,
        destroy_user_session_path,
        help_path,
    } = links;
    const {
        user_signed_in,
        admin,
        hostPagePermission,
        unread_messages_count,
        user_avatar,
        fullname,
    } = user_data;

    const menuItemCommonProps = {
        style: {
            fontSize: "1.5rem"
        },
        className: "search-page-nav-menu-item"
    };

    const items = user_signed_in ? [
        {

            label: 'List my rv',
            icon: <i className="pi pi-dollar" style={{ fontSize: '1.25rem' }}></i>,
            url: list_your_rv_estimate_earnings_path,
            ...menuItemCommonProps,
        },
        ...(
            admin ? [{
                label: 'Super Duper Admin',
                icon: <i className="pi pi-user-edit" style={{ fontSize: '1.25rem' }}></i>,
                url: admin_dashboard_path,
                ...menuItemCommonProps,
            }] : []
        ),
        ...(
            hostPagePermission ? [{
                label: 'Host',
                icon: <i className="pi pi-star" style={{ fontSize: '1.25rem' }}></i>,
                items: [
                    {
                        label: 'Dashboard',
                        url: admin_dashboard_path,
                    },
                    {
                        label: 'Inbox',
                        url: conversations_path,
                    },
                    {
                        label: 'Calendar',
                        url: calendar_path,
                    },
                    {
                        label: 'Fleet',
                        url: fleet_path,
                    },
                    {
                        label: 'Reservations',
                        url: reservations_path,
                    },
                    {
                        label: 'Check In/Out',
                        url: check_in_out_path,
                    },
                    {
                        label: 'Guests',
                        url: guests_path,
                    },
                    {
                        label: 'Settings',
                        url: settings_path,
                    },
                ],
                ...menuItemCommonProps,
            }] : []
        ),
        {
            separator: true,
            ...menuItemCommonProps,
        },
        {
            label: 'Inbox',
            icon: <i className="pi pi-inbox" style={{ fontSize: '1.25rem' }}></i>,
            url: conversations_path,
            ...menuItemCommonProps,
        },
        {
            label: 'Favorites',
            icon: <i className="pi pi-thumbs-up" style={{ fontSize: '1.25rem' }}></i>,
            url: favorites_path,
            ...menuItemCommonProps,
        },
        {
            label: 'Trips',
            icon: <i className="pi pi-car" style={{ fontSize: '1.25rem' }}></i>,
            url: trips_path,
            ...menuItemCommonProps,
        },
        {
            label: 'Past Trips',
            icon: <i className="pi pi-history" style={{ fontSize: '1.25rem' }}></i>,
            url: past_trips_path,
            ...menuItemCommonProps,
        },
        {
            label: 'Profile',
            icon: <i className="pi pi-file" style={{ fontSize: '1.25rem' }}></i>,
            url: edit_user_registration_path,
            ...menuItemCommonProps,
        },
        {
            label: 'Log Out',
            icon: <i className="pi pi-sign-out" style={{ fontSize: '1.25rem' }}></i>,
            url: destroy_user_session_path,
            ...menuItemCommonProps,
        },
    ] : [
        {
            label: 'sign up',
            icon: <i className="pi pi-sign-in" style={{ fontSize: '1.25rem' }}></i>,
            url: new_user_registration_path,
            ...menuItemCommonProps,
        },
        {
            label: 'log in',
            icon: <i className="pi pi-key" style={{ fontSize: '1.25rem' }}></i>,
            url: new_user_session_path,
            ...menuItemCommonProps,
        },
        {
            separator: true,
            ...menuItemCommonProps,
        },
        {

            label: 'list my rv',
            icon: <i className="pi pi-dollar" style={{ fontSize: '1.25rem' }}></i>,
            url: list_your_rv_estimate_earnings_path,
            ...menuItemCommonProps,
        },
    ];

    return (
        <div className='search-page-header-menu-wrapper'>
            <Button label="Help" severity="secondary" icon="pi pi-question-circle" size="large" onClick={() => {
                window.open(help_path, "_blank")
            }} />
            <div className="card flex justify-content-center">
                <TieredMenu model={items} popup ref={menu} breakpoint="767px" style={{ width: "20rem" }} />
                <Button
                    icon="pi pi-bars"
                    severity="secondary"
                    onClick={(e) => menu.current.toggle(e)}
                    size="large"
                >
                    <img alt="user" src="https://upload.wikimedia.org/wikipedia/commons/5/59/User-avatar.svg" className="h-2rem" style={{ marginLeft: "6px" }}></img>
                </Button>
            </div>
        </div>
    )
}

export default Menu;